














































import { defineComponent, useStore } from '@nuxtjs/composition-api'
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import MenuLogotype from '@/components/Header/MenuLogotype.vue'
import BlockButtonsItem from '@/components/BlockButtonsItem.vue'
import CityFromCookie from '@/components/CityFromCookie.vue'

@Component
class SectionNavigation extends Vue {
  @Prop({ default: () => {} }) readonly data: Object | undefined
  static options: any
}

const sectionNavigationProps = SectionNavigation.options.props

export default defineComponent({
  name: 'SectionNavigationNew',
  components: { CityFromCookie, BlockButtonsItem, MenuLogotype },
  props: { ...sectionNavigationProps },
  setup() {
    const { commit } = useStore()
    const showCityPopup = () => commit('popupCityList/SET_SHOWN', true)
    return {
      showCityPopup,
    }
  },
})
